
import Webservice from './WebService';



export default class MediapanelWebService extends Webservice {

    async getDefault(payload) {

        try {
            return await this.get({ endpoint: 'mediapanels/default', data: payload })
        } catch (error) {
            throw error;
        }
    }
    async getMine(payload) {

        try {
            return await this.get({ endpoint: 'mediapanels/mine', data: payload })
        } catch (error) {
            throw error;
        }
    }
    async getMediapanels(payload) {

        try {
            return await this.get({ endpoint: 'mediapanels', data: payload })
        } catch (error) {
            throw error;
        }
    }



    /**
     * Saves Mediapanel
     * 
     * @param {string} key 
     * @param {any} value 
     */
    async save(data ) {

        try {
    
            await this.post({ endpoint: `mediapanels`, data})
             
        } catch (error) {
            throw error;
        }
    }
    async add(type, item ) {

        try {
    
            await this.post({ endpoint: `mediapanels`, data: {    type, item  }})
             
        } catch (error) {
            throw error;
        }
    }
  
    async deleteItem(type, item ) {

        try {
    
            await this.put({ endpoint: `mediapanels`, data: {  type, item  }})
             
        } catch (error) {
            throw error;
        }
    }
  


    async getMediapanel(id) {
        try {
            return await this.get({ endpoint: `mediapanels/${id}` });
        } catch (error) {
            throw error;
        }
    }
 
  


    async deleteMediapanel(id) {
        try {
            return await this.delete({ endpoint: `mediapanels/${id}` });
        } catch (error) {
            throw error;
        }
    }

}